module.exports = __webpack_public_path__ + "img/矩形 2946.c86e4074.png";